// src/pages/DealDetails.jsx
import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hotels from "../data/packages";

const FB  = "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=900&h=560&fit=crop&q=80";
const PJS = { fontFamily:"'Plus Jakarta Sans', sans-serif" };
const S   = { fontFamily:"'DM Sans', sans-serif" };

const BOARD_INFO = {
  "All Inclusive":   { icon:"🍹", desc:"All meals, drinks, snacks and most activities included" },
  "Half Board":      { icon:"🍽", desc:"Breakfast and dinner included daily" },
  "Full Board":      { icon:"🍴", desc:"Breakfast, lunch and dinner included daily" },
  "Bed & Breakfast": { icon:"☕", desc:"Full breakfast included each morning" },
  "Room Only":       { icon:"🛏", desc:"Accommodation only — flexibility to eat locally" },
};

const FACILITIES = ["Swimming Pool","Free WiFi","Air Conditioning","Restaurant","Bar","Spa","Gym","Beach Access","Kids Club","Room Service","Parking","Airport Transfer","24hr Reception","Tennis Court","Water Sports"];

function Gallery({ images, name }) {
  const [main, setMain] = useState(0);
  const [imgErrs, setImgErrs] = useState({});
  const list = images.length ? images : [FB];

  return (
    <div style={{ borderRadius:12, overflow:"hidden", background:"#111" }}>
      <div style={{ position:"relative", height:440, overflow:"hidden" }}>
        <img
          src={imgErrs[main] ? FB : list[main]}
          alt={name}
          style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }}
          onError={() => setImgErrs(e => ({...e, [main]:true}))}
        />
        {list.length > 1 && (
          <>
            <button onClick={()=>setMain(i=>(i-1+list.length)%list.length)}
              style={{ position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", background:"rgba(255,255,255,.88)", border:"none", width:40, height:40, borderRadius:"50%", fontSize:22, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
              &#8249;
            </button>
            <button onClick={()=>setMain(i=>(i+1)%list.length)}
              style={{ position:"absolute", right:14, top:"50%", transform:"translateY(-50%)", background:"rgba(255,255,255,.88)", border:"none", width:40, height:40, borderRadius:"50%", fontSize:22, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
              &#8250;
            </button>
            <div style={{ position:"absolute", bottom:12, right:14, background:"rgba(0,0,0,.55)", color:"#fff", fontSize:12, padding:"3px 9px", borderRadius:5 }}>
              {main+1} / {list.length}
            </div>
          </>
        )}
      </div>
      {list.length > 1 && (
        <div style={{ display:"flex", gap:6, padding:8, background:"#f3f3f3", overflowX:"auto" }}>
          {list.slice(0,8).map((img,i) => (
            <div key={i} onClick={()=>setMain(i)}
              style={{ flexShrink:0, width:70, height:52, cursor:"pointer", borderRadius:5, overflow:"hidden", outline:i===main?"2.5px solid #1565C0":"none" }}>
              <img src={imgErrs[i]?FB:img} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} onError={()=>setImgErrs(e=>({...e,[i]:true}))} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


// ── Related deal card — proper component so useState works ─
function RelatedCard({ r, navigate }) {
  const [rErr, setRErr] = useState(false);
  const rMinP = Math.min(...r.boards.map(b => b.price));
  return (
    <div
      key={r.id}
      onClick={() => navigate(`/deals/${r.id}`)}
      style={{ background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, overflow:"hidden", cursor:"pointer", boxShadow:"0 1px 4px rgba(0,0,0,.06)", transition:"box-shadow .2s, transform .2s" }}
      onMouseEnter={e=>{ e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,.12)"; e.currentTarget.style.transform="translateY(-3px)"; }}
      onMouseLeave={e=>{ e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.06)"; e.currentTarget.style.transform="none"; }}
    >
      <img src={rErr?FB:r.image} alt={r.name} style={{ width:"100%", height:170, objectFit:"cover", display:"block" }} onError={()=>setRErr(true)} loading="lazy" />
      <div style={{ padding:"12px 14px" }}>
        <div style={{ fontSize:12, color:"#888", fontFamily:"'DM Sans',sans-serif" }}>{r.destination}</div>
        <h4 style={{ fontSize:15, fontWeight:800, color:"#1a1a1a", margin:"3px 0 6px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{r.name}</h4>
        <div style={{ fontSize:19, fontWeight:900, color:"#2E7D32", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
          From £{rMinP}<span style={{ fontSize:12, color:"#888", fontWeight:400, marginLeft:3, fontFamily:"'DM Sans',sans-serif" }}>pp</span>
        </div>
      </div>
    </div>
  );
}

export default function DealDetails() {
  const { id }    = useParams();
  const navigate  = useNavigate();
  const pkg       = Hotels.find(p => String(p.id) === String(id));

  const [selectedBoard, setSelectedBoard] = useState(null);
  const [guests,        setGuests]        = useState(2);
  const [rooms,         setRooms]         = useState(1);

  useEffect(() => {
    if (pkg && !selectedBoard) {
      const ai = pkg.boards.find(b => b.type === "All Inclusive");
      setSelectedBoard(ai || pkg.boards[0]);
    }
  }, [pkg]);

  if (!pkg) return (
    <>
      <Navbar />
      <div style={{ maxWidth:600, margin:"80px auto", textAlign:"center", padding:"0 20px" }}>
        <div style={{ fontSize:48, marginBottom:16, opacity:.3 }}>&#9744;</div>
        <h2 style={{ fontWeight:900, marginBottom:8, ...PJS }}>Deal not found</h2>
        <p style={{ color:"#888", marginBottom:24, ...S }}>This deal may no longer be available.</p>
        <Link to="/Hotels" style={{ padding:"12px 24px", background:"#1565C0", color:"#fff", borderRadius:8, fontWeight:700, textDecoration:"none" }}>
          Browse all Accommodation Deals
        </Link>
      </div>
      <Footer />
    </>
  );

  const totalPP = selectedBoard ? selectedBoard.price : 0;
  const total   = totalPP * guests;

  const facs = FACILITIES.slice(0, 12);

  const bookNow = () => {
    const p = new URLSearchParams({
      hotelName: pkg.name,
      destination: pkg.destination,
      country: pkg.country,
      boardBasis: selectedBoard?.type || "",
      guests: String(guests),
      rooms: String(rooms),
      price: String(selectedBoard?.price || 0),
      dealId: String(pkg.id),
    });
    navigate(`/booking?${p}`);
  };

  const related = Hotels.filter(p => p.country === pkg.country && p.id !== pkg.id).slice(0,4);

  return (
    <>
      <Navbar />

      {/* Breadcrumb */}
      <div style={{ background:"#fff", borderBottom:"1px solid #e5e5e5", padding:"12px 20px" }}>
        <div style={{ maxWidth:1200, margin:"0 auto", display:"flex", gap:8, alignItems:"center", fontSize:13, flexWrap:"wrap" }}>
          <Link to="/" style={{ color:"#1565C0", textDecoration:"none" }}>Home</Link>
          <span style={{ color:"#ccc" }}>›</span>
          <Link to="/Hotels" style={{ color:"#1565C0", textDecoration:"none" }}>Accommodation Deals</Link>
          <span style={{ color:"#ccc" }}>›</span>
          <Link to={`/Hotels?destination=${encodeURIComponent(pkg.destination)}`} style={{ color:"#1565C0", textDecoration:"none" }}>{pkg.destination}</Link>
          <span style={{ color:"#ccc" }}>›</span>
          <span style={{ color:"#333", fontWeight:600 }}>{pkg.name}</span>
        </div>
      </div>

      <div style={{ background:"#f7f7f7", minHeight:"100vh", paddingBottom:100 }}>
        <div style={{ maxWidth:1200, margin:"0 auto", padding:"24px 20px" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 360px", gap:28, alignItems:"flex-start" }}>

            {/* LEFT */}
            <div>
              {/* Title */}
              <div style={{ marginBottom:16 }}>
                <div style={{ fontSize:13, color:"#888", marginBottom:4, ...S }}>{pkg.destination}, {pkg.country}</div>
                <h1 style={{ fontSize:"clamp(20px,3vw,28px)", fontWeight:900, color:"#1a1a1a", margin:"0 0 8px", ...PJS }}>{pkg.name}</h1>
                {/* Star rating (decorative) */}
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <span style={{ color:"#f59e0b", fontSize:15, letterSpacing:1 }}>★★★★</span>
                  <span style={{ fontSize:13, color:"#888", ...S }}>4-star hotel</span>
                </div>
              </div>

              <Gallery images={[pkg.image]} name={pkg.name} />

              {/* Highlights */}
              <div style={{ display:"flex", flexWrap:"wrap", gap:8, margin:"16px 0" }}>
                {[`${pkg.destination}`,pkg.country,selectedBoard?.type].filter(Boolean).map((t,i)=>(
                  <span key={i} style={{ background:"#e8f0fe", color:"#1565C0", padding:"5px 12px", borderRadius:999, fontSize:13, fontWeight:600, ...S }}>{t}</span>
                ))}
              </div>

              {/* Description */}
              <div style={{ background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, padding:22, marginBottom:16 }}>
                <h2 style={{ fontSize:17, fontWeight:800, marginBottom:12, color:"#1a1a1a", ...PJS }}>About this holiday</h2>
                <p style={{ fontSize:15, color:"#555", lineHeight:1.75, margin:0, ...S }}>
                  {pkg.description ||
                    `Escape to ${pkg.destination} with this incredible stay. Enjoy stunning beaches, world-class hospitality and unforgettable experiences. This carefully curated deal includes everything you need for the perfect getaway — simply arrive and relax.`}
                </p>
              </div>

              {/* What's included */}
              <div style={{ background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, padding:22, marginBottom:16 }}>
                <h2 style={{ fontSize:17, fontWeight:800, marginBottom:14, color:"#1a1a1a", ...PJS }}>What's included</h2>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:10 }}>
                  {[
                    "Return flights",
                    "Hotel accommodation",
                    selectedBoard?.type || "Board basis as chosen",
                    "Airport transfers",
                    "Luggage allowance",
                    "ABTA travel protection",
                    "24/7 customer support",
                    "Free itinerary planning",
                  ].map((item,i) => (
                    <div key={i} style={{ display:"flex", alignItems:"center", gap:9, fontSize:14, color:"#333", ...S }}>
                      <span style={{ color:"#2E7D32", fontWeight:900, fontSize:15, flexShrink:0 }}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Facilities */}
              <div style={{ background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, padding:22, marginBottom:16 }}>
                <h2 style={{ fontSize:17, fontWeight:800, marginBottom:14, color:"#1a1a1a", ...PJS }}>Hotel facilities</h2>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(170px,1fr))", gap:8 }}>
                  {facs.map((f,i) => (
                    <div key={i} style={{ display:"flex", alignItems:"center", gap:7, background:"#f7f7f7", border:"1px solid #e5e5e5", borderRadius:7, padding:"8px 12px", fontSize:14, color:"#444", ...S }}>
                      <span style={{ color:"#2E7D32", fontWeight:900, fontSize:12 }}>✓</span>{f}
                    </div>
                  ))}
                </div>
              </div>

              {/* Board options */}
              <div style={{ background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, padding:22, marginBottom:16 }}>
                <h2 style={{ fontSize:17, fontWeight:800, marginBottom:6, color:"#1a1a1a", ...PJS }}>Choose your board basis</h2>
                <p style={{ fontSize:13, color:"#888", marginBottom:14, ...S }}>Prices shown are per person</p>
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  {pkg.boards.map(b => {
                    const info = BOARD_INFO[b.type] || { icon:"🏨", desc:"" };
                    const isOn = selectedBoard?.type === b.type;
                    return (
                      <div key={b.type}
                        onClick={() => setSelectedBoard(b)}
                        style={{
                          display:"flex", alignItems:"center", justifyContent:"space-between",
                          padding:"14px 16px", borderRadius:9, cursor:"pointer",
                          border: isOn ? "2px solid #1565C0" : "1.5px solid #e5e5e5",
                          background: isOn ? "#e8f0fe" : "#fafafa",
                          transition:"border-color .15s, background .15s",
                        }}>
                        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                          <span style={{ fontSize:20 }}>{info.icon}</span>
                          <div>
                            <div style={{ fontWeight:800, fontSize:15, color:"#1a1a1a", ...PJS }}>{b.type}</div>
                            <div style={{ fontSize:13, color:"#888", ...S }}>{info.desc}</div>
                          </div>
                        </div>
                        <div style={{ textAlign:"right", flexShrink:0 }}>
                          <div style={{ fontSize:22, fontWeight:900, color:"#2E7D32", ...PJS }}>£{b.price}</div>
                          <div style={{ fontSize:12, color:"#888", ...S }}>per person</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Important info */}
              <div style={{ background:"#fff3e0", border:"1px solid #ffcc80", borderRadius:12, padding:18, marginBottom:16 }}>
                <h3 style={{ fontSize:15, fontWeight:800, marginBottom:10, color:"#E65100", ...PJS }}>Important information</h3>
                <ul style={{ margin:0, paddingLeft:18, fontSize:14, color:"#555", lineHeight:1.8, ...S }}>
                  <li>Valid passport required — must be valid 6 months beyond return date</li>
                  <li>Travel insurance strongly recommended</li>
                  <li>Check visa requirements for your destination</li>
                  <li>Prices are per person, based on 2 adults sharing</li>
                  <li>Departure taxes included in price</li>
                </ul>
              </div>
            </div>

            {/* RIGHT — Booking panel */}
            <div style={{ position:"sticky", top:80 }}>
              <div style={{ background:"#fff", border:"1px solid #e5e5e5", borderRadius:12, overflow:"hidden", boxShadow:"0 4px 20px rgba(0,0,0,.10)" }}>
                {/* Header */}
                <div style={{ background:"#1565C0", color:"#fff", padding:"16px 20px" }}>
                  <div style={{ fontSize:13, opacity:.8, ...S }}>From</div>
                  <div style={{ fontSize:32, fontWeight:900, ...PJS, lineHeight:1 }}>£{totalPP}</div>
                  <div style={{ fontSize:13, opacity:.8, marginTop:2, ...S }}>per person · {selectedBoard?.type || "board basis selected"}</div>
                </div>

                <div style={{ padding:"18px 20px" }}>
                  {/* Guests counter */}
                  <div style={{ marginBottom:14 }}>
                    <div style={{ fontSize:12, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:".07em", marginBottom:8 }}>Guests</div>
                    <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                      <button onClick={()=>setGuests(g=>Math.max(1,g-1))} style={{ width:32,height:32,borderRadius:"50%",border:"1.5px solid #ddd",background:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:"#1565C0",fontWeight:900,fontFamily:"inherit" }}>−</button>
                      <span style={{ fontSize:18, fontWeight:800, color:"#1a1a1a", minWidth:20, textAlign:"center", ...PJS }}>{guests}</span>
                      <button onClick={()=>setGuests(g=>Math.min(10,g+1))} style={{ width:32,height:32,borderRadius:"50%",border:"1.5px solid #ddd",background:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:"#1565C0",fontWeight:900,fontFamily:"inherit" }}>+</button>
                      <span style={{ fontSize:14, color:"#888", ...S }}>Adult{guests!==1?"s":""}</span>
                    </div>
                  </div>

                  {/* Rooms counter */}
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontSize:12, fontWeight:700, color:"#888", textTransform:"uppercase", letterSpacing:".07em", marginBottom:8 }}>Rooms</div>
                    <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                      <button onClick={()=>setRooms(r=>Math.max(1,r-1))} style={{ width:32,height:32,borderRadius:"50%",border:"1.5px solid #ddd",background:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:"#1565C0",fontWeight:900,fontFamily:"inherit" }}>−</button>
                      <span style={{ fontSize:18, fontWeight:800, color:"#1a1a1a", minWidth:20, textAlign:"center", ...PJS }}>{rooms}</span>
                      <button onClick={()=>setRooms(r=>Math.min(5,r+1))} style={{ width:32,height:32,borderRadius:"50%",border:"1.5px solid #ddd",background:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",color:"#1565C0",fontWeight:900,fontFamily:"inherit" }}>+</button>
                      <span style={{ fontSize:14, color:"#888", ...S }}>Room{rooms!==1?"s":""}</span>
                    </div>
                  </div>

                  {/* Total */}
                  {selectedBoard && (
                    <div style={{ background:"#e8f5e9", border:"1px solid #a5d6a7", borderRadius:8, padding:"12px 14px", marginBottom:16 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:14, marginBottom:4 }}>
                        <span style={{ color:"#555", ...S }}>£{totalPP} × {guests} guests</span>
                        <span style={{ fontWeight:700, color:"#1a1a1a", ...PJS }}>£{total.toLocaleString()}</span>
                      </div>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:14 }}>
                        <span style={{ color:"#555", ...S }}>Board basis</span>
                        <span style={{ fontWeight:700, color:"#1a1a1a", ...PJS }}>{selectedBoard.type}</span>
                      </div>
                      <div style={{ borderTop:"1px solid #a5d6a7", marginTop:10, paddingTop:10, display:"flex", justifyContent:"space-between" }}>
                        <span style={{ fontWeight:800, color:"#1a1a1a", fontSize:15, ...PJS }}>Total</span>
                        <span style={{ fontWeight:900, color:"#2E7D32", fontSize:22, ...PJS }}>£{total.toLocaleString()}</span>
                      </div>
                    </div>
                  )}

                  {/* Book button */}
                  <button
                    onClick={bookNow}
                    style={{ width:"100%", padding:"14px", background:"#2E7D32", color:"#fff", border:"none", borderRadius:8, fontSize:16, fontWeight:800, cursor:"pointer", ...PJS, marginBottom:10, transition:"background .2s" }}
                    onMouseEnter={e=>e.target.style.background="#1B5E20"}
                    onMouseLeave={e=>e.target.style.background="#2E7D32"}
                  >
                    Book now
                  </button>
                  <a href="tel:02030190055" style={{ display:"block", textAlign:"center", padding:11, background:"#f3f4f6", color:"#333", borderRadius:7, fontWeight:700, fontSize:14, textDecoration:"none", marginBottom:8, ...S }}>
                    Call 020 3019 0055
                  </a>
                  <a href={`https://wa.me/447487672075?text=Interested in ${encodeURIComponent(pkg.name)}`} target="_blank" rel="noreferrer"
                    style={{ display:"block", textAlign:"center", padding:11, background:"#25D366", color:"#fff", borderRadius:7, fontWeight:700, fontSize:14, textDecoration:"none", ...S }}>
                    WhatsApp us
                  </a>

                  {/* Trust badges */}
                  <div style={{ borderTop:"1px solid #f0f0f0", paddingTop:14, marginTop:14 }}>
                    {["Best price guarantee","No hidden fees","Secure payment","Expert UK travel advisors"].map((t,i)=>(
                      <div key={i} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:7, fontSize:13, color:"#555", ...S }}>
                        <span style={{ color:"#2E7D32", fontWeight:900 }}>✓</span>{t}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Related Deals */}
          {related.length > 0 && (
            <div style={{ marginTop:48 }}>
              <h2 style={{ fontSize:20, fontWeight:800, marginBottom:6, color:"#1a1a1a", ...PJS }}>More holidays in {pkg.country}</h2>
              <p style={{ fontSize:14, color:"#888", marginBottom:20, ...S }}>You might also like these similar Accommodation Deals</p>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))", gap:18 }}>
                {related.map(r => <RelatedCard key={r.id} r={r} navigate={navigate} />)}
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />

      <style>{`
        @media(max-width:900px) {
          div[style*="gridTemplateColumns: 1fr 360px"] {
            grid-template-columns: 1fr !important;
          }
          div[style*="position:sticky"], div[style*="position: sticky"] {
            position: relative !important;
            top: auto !important;
          }
        }
      `}</style>
    </>
  );
}